exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ReloadPage__header___13Bag{color:#000 !important;max-width:20em}", "", {"version":3,"sources":["/opt/TeamCity/buildAgentTest/work/87d7e5c6c6455c0d/packages/grading/src/components/reload/ReloadPage.scss"],"names":[],"mappings":"AAAA,4BACE,sBACA,cAAA,CAAA","file":"ReloadPage.scss","sourcesContent":[".header {\n  color: black !important;\n  max-width: 20em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "ReloadPage__header___13Bag"
};